import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SearchBar } from "./SearchBar";
import { FundsTable } from "./FundsTable";
import { Fund } from "@/types/Fund";

interface FundsCardProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isLoading: boolean;
  filteredFunds: Fund[];
  onEditFund: (fund: Fund) => void;
}

export const FundsCard: React.FC<FundsCardProps> = ({
  searchQuery,
  setSearchQuery,
  isLoading,
  filteredFunds,
  onEditFund,
}) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Fund Management</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-4 mb-4">
          <SearchBar
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </div>

        <FundsTable
          isLoading={isLoading}
          filteredFunds={filteredFunds}
          onEditFund={onEditFund}
        />
      </CardContent>
    </Card>
  );
};
